(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const banners = document.querySelectorAll('.pn-banner');
    if (!banners.length) return;

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      banners.forEach((b) => b.classList.add('is-in'));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.2 }
    );

    banners.forEach((b) => io.observe(b));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feat-pro"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const nodes = document.querySelectorAll('[data-pn-feature]');
    if (!nodes.length) return;

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      nodes.forEach((n) => n.classList.add('is-in'));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.15 }
    );

    nodes.forEach((n) => io.observe(n));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const grids = document.querySelectorAll('[data-pn-grid]');
    if (!grids.length) return;

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      document.querySelectorAll('.pn-card').forEach((c) => c.classList.add('is-in'));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const card = entry.target;
          const idx = Number(card.dataset.pnIdx || 0);
          const delay = Math.min(idx * 60, 360);
          setTimeout(() => card.classList.add('is-in'), delay);
          io.unobserve(card);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    grids.forEach((grid) => {
      grid.querySelectorAll('.pn-card').forEach((card, i) => {
        card.dataset.pnIdx = i;
        io.observe(card);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const form = document.querySelector('#pn-contact-form');
    if (!form) return;

    // Prevent double-submit
    form.addEventListener('submit', () => {
      const btn = form.querySelector('.pn-contact__submit');
      if (btn) {
        btn.disabled = true;
        const label = btn.querySelector('span');
        if (label) label.textContent = 'SENDING…';
      }
    });

    // Smooth scroll to success / errors on page load if present
    const success = document.querySelector('.pn-contact__success');
    const errors = document.querySelector('.pn-contact__errors');
    const target = success || errors;
    if (target) {
      const rect = target.getBoundingClientRect();
      if (rect.top < 0 || rect.top > window.innerHeight) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-legal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Smooth scroll for internal TOC links
    document.querySelectorAll('.pn-legal__toc-list a[href^="#"]').forEach((link) => {
      link.addEventListener('click', (e) => {
        const id = link.getAttribute('href').slice(1);
        const target = document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', '#' + id);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-shipping-returns"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const nodes = document.querySelectorAll('[data-pn-policy]');
    if (!nodes.length) return;

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      nodes.forEach((n) => n.classList.add('is-in'));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.12 }
    );

    nodes.forEach((n) => io.observe(n));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["philosophy"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const nodes = document.querySelectorAll('[data-pn-philosophy]');
    if (!nodes.length) return;

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      nodes.forEach((n) => n.classList.add('is-in'));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.2 }
    );

    nodes.forEach((n) => io.observe(n));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-pn-product]');
    if (!root) return;

    const variantsScript = document.querySelector('[data-pn-variants]');
    let variants = [];
    try { variants = JSON.parse(variantsScript?.textContent || '[]'); } catch (e) {}
    if (!variants.length) return;

    const form = root.querySelector('[data-pn-form]');
    const atcButton = root.querySelector('[data-pn-atc]');
    const atcLabel = root.querySelector('[data-pn-atc-label]');
    const priceEl = root.querySelector('[data-pn-price]');
    const variantIdInput = root.querySelector('[data-pn-variant-id]');
    const soldOutLabel = root.querySelector('[data-pn-sold-out-label]');

    const selectedOptions = {};
    root.querySelectorAll('.pn-option').forEach((optEl) => {
      const name = optEl.dataset.pnOptionName;
      const active = optEl.querySelector('.pn-pill.is-selected, .pn-swatch.is-selected');
      if (active) selectedOptions[name] = active.dataset.pnValue;
    });

    const isFullySoldOut = () => {
      if (!variants.length) return false;
      return variants.every((v) => {
        if (!v.available) return true;
        const managed = v.inventory_management;
        const qty = v.inventory_quantity;
        if (managed === null || managed === 'none' || typeof managed === 'undefined') return false;
        return qty <= 0;
      });
    };

    const forceSoldOutText = () => {
      if (atcLabel && /unavailable/i.test(atcLabel.textContent)) {
        atcLabel.textContent = 'SOLD OUT';
      }
    };

    const updateUI = (variant) => {
      if (!variant) {
        if (atcButton) atcButton.disabled = true;
        if (atcLabel) atcLabel.textContent = 'SOLD OUT';
        if (soldOutLabel && isFullySoldOut()) soldOutLabel.removeAttribute('hidden');
        return;
      }

      if (variantIdInput) variantIdInput.value = variant.id;

      if (priceEl) {
        const formatted = (variant.price / 100).toFixed(2);
        priceEl.textContent = `$${formatted}`;
      }

      if (atcButton) atcButton.disabled = !variant.available;
      if (atcLabel) atcLabel.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';

      if (soldOutLabel) {
        if (isFullySoldOut()) {
          soldOutLabel.removeAttribute('hidden');
        } else {
          soldOutLabel.setAttribute('hidden', '');
        }
      }

      forceSoldOutText();
    };

    const findVariant = () => {
      const optionNames = Object.keys(selectedOptions);
      if (!optionNames.length) return variants[0];
      return variants.find((v) => {
        return optionNames.every((name, idx) => {
          return v.options[idx] === selectedOptions[name];
        });
      });
    };

    root.querySelectorAll('.pn-pill, .pn-swatch').forEach((btn) => {
      btn.addEventListener('click', () => {
        const optionName = btn.dataset.pnOption;
        const value = btn.dataset.pnValue;
        if (!optionName || !value) return;

        const parent = btn.closest('.pn-option__values');
        parent.querySelectorAll('.pn-pill, .pn-swatch').forEach((el) => {
          el.classList.remove('is-selected');
          if (el.hasAttribute('aria-pressed')) el.setAttribute('aria-pressed', 'false');
        });

        btn.classList.add('is-selected');
        if (btn.hasAttribute('aria-pressed')) btn.setAttribute('aria-pressed', 'true');

        const group = btn.closest('.pn-option');
        const labelEl = group?.querySelector('[data-pn-option-selected]');
        if (labelEl) labelEl.textContent = value;

        selectedOptions[optionName] = value;
        updateUI(findVariant());
      });
    });

    const thumbs = root.querySelectorAll('[data-pn-thumb-index]');
    const galleryTrack = root.querySelector('.pn-product__gallery-track');
    if (thumbs.length && galleryTrack) {
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const idx = parseInt(thumb.dataset.pnThumbIndex, 10);
          const target = galleryTrack.querySelector(`[data-pn-image-index="${idx}"]`);
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          thumbs.forEach((t) => t.classList.remove('is-active'));
          thumb.classList.add('is-active');
        });
      });
    }

    updateUI(findVariant());

    setTimeout(() => {
      forceSoldOutText();
      if (soldOutLabel && isFullySoldOut()) soldOutLabel.removeAttribute('hidden');
    }, 300);

    setTimeout(forceSoldOutText, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-related"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* ---------- Card gallery slides ---------- */
    document.querySelectorAll('[data-pn-related] [data-pn-card]').forEach((card) => {
      const media = card.querySelector('[data-pn-media]');
      const slides = card.querySelectorAll('[data-pn-slide]');
      if (!media || slides.length < 2) return;

      let index = 0;
      const total = slides.length;

      const setActive = (i) => {
        slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
        index = i;
      };

      const prev = card.querySelector('[data-pn-prev]');
      const next = card.querySelector('[data-pn-next]');

      if (prev) {
        prev.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          setActive((index - 1 + total) % total);
        });
      }
      if (next) {
        next.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          setActive((index + 1) % total);
        });
      }
    });

    /* ---------- Adaptive arrow color ---------- */
    const analyzeImageBrightness = (imgEl, cardEl) => {
      if (!imgEl || !cardEl) return;

      const apply = (brightness) => {
        if (brightness < 150) {
          cardEl.classList.add('is-dark-image');
          cardEl.classList.remove('is-light-image');
        } else {
          cardEl.classList.add('is-light-image');
          cardEl.classList.remove('is-dark-image');
        }
      };

      const compute = () => {
        try {
          const canvas = document.createElement('canvas');
          const size = 24;
          canvas.width = size;
          canvas.height = size;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(imgEl, 0, 0, size, size);

          const { data } = ctx.getImageData(0, 0, size, size);
          let total = 0;
          let count = 0;

          for (let i = 0; i < data.length; i += 16) {
            const r = data[i];
            const g = data[i + 1];
            const b = data[i + 2];
            const a = data[i + 3];
            if (a < 128) continue;
            const lum = 0.299 * r + 0.587 * g + 0.114 * b;
            total += lum;
            count++;
          }
          if (count === 0) return;
          apply(total / count);
        } catch (err) {
          cardEl.classList.add('is-light-image');
        }
      };

      if (imgEl.complete && imgEl.naturalWidth > 0) {
        compute();
      } else {
        imgEl.addEventListener('load', compute, { once: true });
      }
    };

    document.querySelectorAll('[data-pn-related] [data-pn-card]').forEach((card) => {
      const firstSlide = card.querySelector('.pn-card__slide.is-active');
      const img = firstSlide?.querySelector('img');
      analyzeImageBrightness(img, card);

      const prev = card.querySelector('[data-pn-prev]');
      const next = card.querySelector('[data-pn-next]');
      const reanalyze = () => {
        const activeSlide = card.querySelector('.pn-card__slide.is-active');
        const img2 = activeSlide?.querySelector('img');
        analyzeImageBrightness(img2, card);
      };

      prev?.addEventListener('click', () => setTimeout(reanalyze, 50));
      next?.addEventListener('click', () => setTimeout(reanalyze, 50));
    });

    /* ---------- Gentle slide-in for the section ---------- */
    const section = document.querySelector('[data-pn-related]');
    if (section) {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) {
        section.classList.add('is-in');
      } else {
        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-in');
              io.unobserve(entry.target);
            });
          },
          { threshold: 0.12, rootMargin: '0px 0px -10% 0px' }
        );
        io.observe(section);
      }
    }

    /* ---------- Staggered fade-in for the cards ---------- */
    const items = document.querySelectorAll('[data-pn-related-item]');
    if (items.length) {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) {
        items.forEach((i) => i.classList.add('is-in'));
      } else {
        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-in');
              io.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -6% 0px', threshold: 0.08 }
        );
        items.forEach((el) => io.observe(el));
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-prod"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* ---------- Card gallery slides ---------- */
    document.querySelectorAll('[data-pn-related] [data-pn-card]').forEach((card) => {
      const media = card.querySelector('[data-pn-media]');
      const slides = card.querySelectorAll('[data-pn-slide]');
      if (!media || slides.length < 2) return;

      let index = 0;
      const total = slides.length;

      const setActive = (i) => {
        slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
        index = i;
      };

      const prev = card.querySelector('[data-pn-prev]');
      const next = card.querySelector('[data-pn-next]');

      if (prev) {
        prev.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          setActive((index - 1 + total) % total);
        });
      }
      if (next) {
        next.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          setActive((index + 1) % total);
        });
      }
    });

    /* ---------- Adaptive arrow color ---------- */
    const analyzeImageBrightness = (imgEl, cardEl) => {
      if (!imgEl || !cardEl) return;

      const apply = (brightness) => {
        if (brightness < 150) {
          cardEl.classList.add('is-dark-image');
          cardEl.classList.remove('is-light-image');
        } else {
          cardEl.classList.add('is-light-image');
          cardEl.classList.remove('is-dark-image');
        }
      };

      const compute = () => {
        try {
          const canvas = document.createElement('canvas');
          const size = 24;
          canvas.width = size;
          canvas.height = size;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(imgEl, 0, 0, size, size);

          const { data } = ctx.getImageData(0, 0, size, size);
          let total = 0;
          let count = 0;

          for (let i = 0; i < data.length; i += 16) {
            const r = data[i];
            const g = data[i + 1];
            const b = data[i + 2];
            const a = data[i + 3];
            if (a < 128) continue;
            const lum = 0.299 * r + 0.587 * g + 0.114 * b;
            total += lum;
            count++;
          }
          if (count === 0) return;
          apply(total / count);
        } catch (err) {
          cardEl.classList.add('is-light-image');
        }
      };

      if (imgEl.complete && imgEl.naturalWidth > 0) {
        compute();
      } else {
        imgEl.addEventListener('load', compute, { once: true });
      }
    };

    document.querySelectorAll('[data-pn-related] [data-pn-card]').forEach((card) => {
      const firstSlide = card.querySelector('.pn-card__slide.is-active');
      const img = firstSlide?.querySelector('img');
      analyzeImageBrightness(img, card);

      const prev = card.querySelector('[data-pn-prev]');
      const next = card.querySelector('[data-pn-next]');
      const reanalyze = () => {
        const activeSlide = card.querySelector('.pn-card__slide.is-active');
        const img2 = activeSlide?.querySelector('img');
        analyzeImageBrightness(img2, card);
      };

      prev?.addEventListener('click', () => setTimeout(reanalyze, 50));
      next?.addEventListener('click', () => setTimeout(reanalyze, 50));
    });

    /* ---------- Gentle slide-in for the section ---------- */
    const section = document.querySelector('[data-pn-related]');
    if (section) {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) {
        section.classList.add('is-in');
      } else {
        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-in');
              io.unobserve(entry.target);
            });
          },
          { threshold: 0.12, rootMargin: '0px 0px -10% 0px' }
        );
        io.observe(section);
      }
    }

    /* ---------- Staggered fade-in for cards ---------- */
    const items = document.querySelectorAll('.pn-related__grid-item');
    if (items.length) {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) {
        items.forEach((i) => i.classList.add('is-in'));
      } else {
        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-in');
              io.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -6% 0px', threshold: 0.08 }
        );
        items.forEach((el) => io.observe(el));
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ship-ret"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const nodes = document.querySelectorAll('[data-pn-policy]');
    if (!nodes.length) return;

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      nodes.forEach((n) => n.classList.add('is-in'));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.12 }
    );

    nodes.forEach((n) => io.observe(n));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* ---------- Card gallery slides ---------- */
    document.querySelectorAll('[data-pn-card]').forEach((card) => {
      const media = card.querySelector('[data-pn-media]');
      const slides = card.querySelectorAll('[data-pn-slide]');
      if (!media || slides.length < 2) return;

      let index = 0;
      const total = slides.length;

      const setActive = (i) => {
        slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
        index = i;
      };

      const prev = card.querySelector('[data-pn-prev]');
      const next = card.querySelector('[data-pn-next]');

      if (prev) {
        prev.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          setActive((index - 1 + total) % total);
        });
      }
      if (next) {
        next.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          setActive((index + 1) % total);
        });
      }
    });

    /* ---------- Grid fade-in ---------- */
    const gridItems = document.querySelectorAll('.pn-collection-grid__item, .pn-shop__grid-item');
    if (gridItems.length) {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) {
        gridItems.forEach((i) => i.classList.add('is-in'));
      } else {
        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              const el = entry.target;
              const idx = Number(el.dataset.pnIdx || 0);
              const delay = Math.min(idx * 50, 300);
              setTimeout(() => el.classList.add('is-in'), delay);
              io.unobserve(el);
            });
          },
          { rootMargin: '0px 0px -6% 0px', threshold: 0.08 }
        );
        gridItems.forEach((el, i) => {
          el.dataset.pnIdx = i;
          io.observe(el);
        });
      }
    }

    /* ---------- Collection image fade-in ---------- */
    const imageCells = document.querySelectorAll('.pn-collection-grid__image-cell');
    imageCells.forEach((el) => {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) { el.classList.add('is-in'); return; }
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          });
        },
        { threshold: 0.15 }
      );
      io.observe(el);
    });

    /* ---------- Filter drawer toggle ---------- */
    const filterToggle = document.querySelector('[data-pn-filter-toggle]');
    const filterPanel = document.querySelector('[data-pn-filters]');
    if (filterToggle && filterPanel) {
      filterToggle.addEventListener('click', () => {
        const isHidden = filterPanel.hasAttribute('hidden');
        if (isHidden) {
          filterPanel.removeAttribute('hidden');
          filterToggle.setAttribute('aria-expanded', 'true');
        } else {
          filterPanel.setAttribute('hidden', '');
          filterToggle.setAttribute('aria-expanded', 'false');
        }
      });
    }

    /* ---------- Sort change ---------- */
    const sortSelect = document.querySelector('[data-pn-sort]');
    if (sortSelect) {
      sortSelect.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        window.location.href = url.toString();
      });
    }

    /* ---------- Adaptive arrow color ---------- */
    const analyzeImageBrightness = (imgEl, cardEl) => {
      if (!imgEl || !cardEl) return;

      const apply = (brightness) => {
        if (brightness < 150) {
          cardEl.classList.add('is-dark-image');
          cardEl.classList.remove('is-light-image');
        } else {
          cardEl.classList.add('is-light-image');
          cardEl.classList.remove('is-dark-image');
        }
      };

      const compute = () => {
        try {
          const canvas = document.createElement('canvas');
          const size = 24;
          canvas.width = size;
          canvas.height = size;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(imgEl, 0, 0, size, size);

          const { data } = ctx.getImageData(0, 0, size, size);
          let total = 0;
          let count = 0;

          for (let i = 0; i < data.length; i += 16) {
            const r = data[i];
            const g = data[i + 1];
            const b = data[i + 2];
            const a = data[i + 3];
            if (a < 128) continue;
            const lum = 0.299 * r + 0.587 * g + 0.114 * b;
            total += lum;
            count++;
          }

          if (count === 0) return;
          apply(total / count);
        } catch (err) {
          cardEl.classList.add('is-light-image');
        }
      };

      if (imgEl.complete && imgEl.naturalWidth > 0) {
        compute();
      } else {
        imgEl.addEventListener('load', compute, { once: true });
      }
    };

    document.querySelectorAll('[data-pn-card]').forEach((card) => {
      const firstSlide = card.querySelector('.pn-card__slide.is-active');
      const img = firstSlide?.querySelector('img');
      analyzeImageBrightness(img, card);
    });

    document.querySelectorAll('[data-pn-card]').forEach((card) => {
      const prev = card.querySelector('[data-pn-prev]');
      const next = card.querySelector('[data-pn-next]');
      const reanalyze = () => {
        const activeSlide = card.querySelector('.pn-card__slide.is-active');
        const img = activeSlide?.querySelector('img');
        analyzeImageBrightness(img, card);
      };
      prev?.addEventListener('click', () => setTimeout(reanalyze, 50));
      next?.addEventListener('click', () => setTimeout(reanalyze, 50));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
